import { Text, headingFontStyles, textFontStyles } from '@makemydeal/dr-ui-bricks-components';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';
import styled from 'styled-components';

export const SectionWrapper = styled.div`
    border-radius: 24px;
    padding: 16px;
    background: ${({ theme }) => theme.uiBricks.modalBackgroundColor || '#ffffff'};
    flex: 1 1 0;
`;

export const SectionHeader = styled.div`
    display: flex;
    justify-content: space-between;
    gap: 6px;
    padding-bottom: 11px;
    align-items: center;

    @media (max-width: ${BreakPoints.PHONE}) {
        flex-direction: column;
    }
`;

export const SectionSubtitle = styled(Text)`
    color: ${({ theme }) => theme.uiBricks?.dashboardDrActivityDashboardRemoveCoBuyerCloseMsgSvgFill || '#727479'};
`;

export const WarrantyTable = styled.table`
    width: 100%;
    border-collapse: collapse;
`;

export const TableHead = styled.thead`
    background: #f4f4f4;
`;

export const TableBody = styled.tbody``;

export const TableRow = styled.tr`
    border-bottom: ${({ theme }) => `1px solid ${theme.uiBricks?.paymentTermsCashDisclaimerBackgroundColor || '#e4e5e6'}`};
`;

export const TableHeader = styled.th`
    text-align: left;
    padding: 10px 12px;
    ${headingFontStyles(7, 'bold')}
    color: ${({ theme }) => theme.uiBricks.commonCardIconColor || '#000000'};
    border-bottom: ${({ theme }) => `1px solid ${theme.uiBricks.paymentTermsCashDisclaimerBackgroundColor || '#e4e5e6'}`};
`;

export const TableCell = styled.td`
    padding: 10px;
    ${textFontStyles('small', 'regular')}
    color: ${({ theme }) => theme.uiBricks.labelFontColor};
`;
